<ul class="list-unstyled mb-4">
  <li *ngFor="let link of links">
    <a [href]="link.url" [innerHtml]="link.title" 
      [target]="link.external ? '_blank' : '_self'"
      class="d-block border border-primary rounded py-2 px-3 font-weight-bold bg-white mb-1">
    </a>
  </li>
</ul>